// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCdG3PfTurUGLriA3KGh67_jwR6tNtZ5L0",
  authDomain: "lowen-ff3ae.firebaseapp.com",
  projectId: "lowen-ff3ae",
  storageBucket: "lowen-ff3ae.appspot.com",
  messagingSenderId: "174298724137",
  appId: "1:174298724137:web:004476bff0a3f08078a938",
  measurementId: "G-FZ0DVZJGCC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
const analytics = getAnalytics(app);

